import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';

import config from './config';
import { CssBaseline } from '@mui/material';

import Layout from './layouts/index';
import { AuthenticationService } from './services';
import { SideNavbarProvider, SnackbarProvider, UnreadProvider, UserProvider } from './contexts';
import Snackbar from './components/utils/Snackbar';
import Theme from './Theme';

axios.defaults.baseURL = config.apiBaseUrl;

axios.interceptors.request.use(req => {
  const token = AuthenticationService.getAuthToken();
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

axios.interceptors.response.use(
  res => res,
  err => {
    if (err?.response?.status === 401 && !window.location.href.includes('/auth')) {
      window.location.href = `/auth?returnUrl=${encodeURIComponent(window.location.href.replace(window.location.origin, ''))}`;
    } else throw err;
  },
);

export const App = () => {
  const { i18n } = useTranslation();
  useEffect(() => {
    document.dir = i18n.dir();
  }, [i18n, i18n.language]);

  return (
    <BrowserRouter>
      <Theme language={i18n.language}>
        <CssBaseline />
        <UserProvider>
          <SideNavbarProvider>
            <SnackbarProvider>
              <UnreadProvider>
                <Layout />
              </UnreadProvider>
              <Snackbar />
            </SnackbarProvider>
          </SideNavbarProvider>
        </UserProvider>
      </Theme>
    </BrowserRouter>
  );
};
